export default {
      id: "rating-usage",
      viewBox: "0 0 22 21",
      url: __webpack_public_path__ + "img/icons.svg#rating",
      toString: function () {
        return this.url;
      }
    }